jQuery( function( $ ) {
  $(document).scroll(function () {
    var $nav = $(".navbar");
    $nav.toggleClass('scrolled fixed-top', $(this).scrollTop() > $nav.height());
    $(".navbar-nav").toggleClass('justify-content-center', $(this).scrollTop() > $nav.height());
    $(".navbar-nav").toggleClass('justify-content-end', $(this).scrollTop() < $nav.height());
  });

  /* filtering projects */
  jQuery(function ($) {
    var $items = $(".items .item");
    var $btns = $(".filter .btn").on("click", function () {
      var active = $btns
        .removeClass("current")
        .filter(this)
        .addClass("current")
        .data("filter");
      $items
        .hide()
        .filter("." + active)
        .fadeIn(450);
    });
  });

/* Slick */
$('#project-slick').slick({
  centerMode: false,
  arrows: false,
  dots: true,
  centerPadding: '60px',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

/* Back to top */
var btn = $('#btt');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

});
var AOS = require('aos');
AOS.init();